export enum GlobalRatingPeriod {
  FALL_2025 = 47
}
